import { Link, useNavigate } from "react-router-dom";
import { Ship, User, LogOut, LayoutDashboard, Ticket } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

export function Navbar({ transparent = false }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      className={`sticky top-0 z-50 ${transparent ? "glass" : "bg-white border-b border-border"}`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="logo-link">
          <span className="h-9 w-9 rounded-md bg-primary flex items-center justify-center">
            <Ship className="h-5 w-5 text-white" strokeWidth={1.75} />
          </span>
          <span className="font-display font-bold text-lg tracking-tight text-primary">WaveLine</span>
        </Link>

        <nav className="flex items-center gap-2">
          {user && user.role === "admin" && (
            <Button variant="ghost" size="sm" onClick={() => navigate("/admin")} data-testid="nav-admin-btn">
              <LayoutDashboard className="h-4 w-4 mr-1.5" /> Admin
            </Button>
          )}
          {user ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" size="sm" data-testid="user-menu-btn">
                  <User className="h-4 w-4 mr-1.5" /> {user.name?.split(" ")[0] || "Account"}
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-48">
                <DropdownMenuItem onClick={() => navigate("/my-bookings")} data-testid="nav-mybookings">
                  <Ticket className="h-4 w-4 mr-2" /> My Bookings
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => { logout(); navigate("/"); }} data-testid="nav-logout">
                  <LogOut className="h-4 w-4 mr-2" /> Log out
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <>
              <Button variant="ghost" size="sm" onClick={() => navigate("/login")} data-testid="nav-login-btn">
                Sign in
              </Button>
              <Button size="sm" className="bg-accent hover:bg-accent/90 text-white" onClick={() => navigate("/register")} data-testid="nav-register-btn">
                Get started
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
